import styled from "@emotion/styled";
import { Avatar, Box, InputLabel, Paper } from "@mui/material";

export const ProfileAvatar = styled(Avatar)({
  width: 100,
  height: 100,
  fontSize: 36,
});

export const UpdateAvatarButton = styled(InputLabel)({
  width: 28,
  height: 28,
  border: `2px solid rgba(255, 255, 255, 0)`,
  borderColor: "#2196F3",
  backgroundColor: "white",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50%",
  cursor: "pointer",
});

export const ProfileContainer = styled(Box)({
  marginTop: 48,
  display: "flex",
  gap: 64,
});

export const AvatarContainer = styled(Paper)({
  width: 280,
  padding: "72px 12px",
  display: "flex",
  flexDirection: "column",
  flexShrink: 0,
  justifyContent: "center",
  alignItems: "center",
  gap: 8,
});

export const PasswordForm = styled(Box)({
  minWidth: 450,
  display: "flex",
  flexDirection: "column",
  gap: 16,
  paddingTop: 8,
  paddingBottom: 12,
});
